import React, { PureComponent } from 'react';
import { Image } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

//IMAGES
import ErrorIcon from "../images/svgs/Error.svg";

class Product extends PureComponent {
  redirectToDetail = () => {
    const {currency} = this.props
    const price = this.props.media.prices &&  
                  this.props.media.prices.length > 0 &&
                  this.props.media.prices.find(pr => pr.currency === currency)

    let productObj = this.props.media
    // console.log('props', this.props);
     window.dataLayer.push({
    'event': 'productClick',
    'ecommerce': {
      'click': {
        'actionField': {'list': 'Explore Produts'},      // Optional list property.
        'products': [{
          'name': productObj.name, // Name or ID is required.
          'id': productObj.id,
          // 'brand': productObj.brand,
          // 'category': productObj.category,
          // 'variant': productObj.variant,
          // 'list_name': productObj.list_name,
          // 'list_id': productObj.list_id,
          // 'index': productObj.index,
          // 'quantity': productObj.quantity,
          'price': price.price
        }]
       }
     },
    //  'eventCallback': function() {
    //    document.location = `/clientwebsite2/productDetail/${this.props.media.instagram_pid}`
    //  }
    });
    //  window.dataLayer.push({
    //   'event': 'select_item',
    //   'ecommerce': {
    //     'items': [{
    //       'item_name': productObj.name, // Name or ID is required.
    //       'item_id': productObj.id,
    //       // 'item_brand': productObj.brand,
    //       // 'item_category': productObj.category,
    //       // 'item_category_2': productObj.category_2,
    //       // 'item_category_3': productObj.category_3,
    //       // 'item_category_4': productObj.category_4,
    //       // 'item_variant': productObj.variant,
    //       // 'item_list_name': productObj.list_name,
    //       // 'item_list_id': productObj.list_id,
    //       // 'index': productObj.index,
    //       // 'quantity': productObj.quantity,
    //       'price': price.price
    //     }]
    //   }
    // });
    this.props.history.push({
      pathname: `/clientwebsite2/productDetail/${this.props.media.instagram_pid}`,
      // Change later to /productDetail
      state: {
        media: this.props.media,
        whatsappLink: this.props.whatsappLink,
        businessName: this.props.businessName,
      },
    });
  };
  render() {
    const { selected, dashboard, currency, translate } = this.props;
    const price = this.props.media.prices && this.props.media.prices.length > 0 && this.props.media.prices.find(pr => pr.currency === currency)
    return (
      <div onClick={() => {
        if (dashboard) {
          this.props.addToCart(this.props.media)
        } else
          this.redirectToDetail()
      }} key={this.props.media.imageId} className="exploreProductDetailContainer">
        {selected ?
          <Image
            className="notSelected"
            src={ErrorIcon}
          />
          : <div className="emptyDiv"></div>
        }
        <div className={`imageDiv ${selected ? "selectedImage" : ""}  ${!this.props.media.name && !price && "removeProductInfo"}`}>
          <Image src={this.props.media.media && this.props.media.media.length > 0 && this.props.media.media[0].url} alt={this.props.media.productName} />
        </div>
        {(this.props.media.name || price) &&
          <div className="prodInfo">
            <h4 className="productName">
              {this.props.media.name ? this.props.media.name : ''}
            </h4>

            <h3 className={"productPrice"}>
              {price ? (
                <div>
                  <span className={`${this.props.language === "ar" && "arabic"}`}>{translate[price.currency]}</span>
                  {price.price}
                </div>
              ) : (
                  <div style={{ height: 17 }}>

                  </div>
                )}
            </h3>
          </div>
        }
      </div>

    );
  }
}

export default withRouter(Product);



// WEBPACK FOOTER //
// ./src/components/ExploreProduct.js